import leavesService from '@/services/leaves.service'

export default {
  namespaced: true,
  state: {
    leaves: [],
    loading: false,
    error: null
  },
  mutations: {
    SET_LEAVES(state, leaves) {
      state.leaves = leaves
    },
    ADD_LEAVE(state, leave) {
      state.leaves.push(leave)
    },
    UPDATE_LEAVE_STATUS(state, { id, status }) {
      const leave = state.leaves.find(l => l.id === id)
      if (leave) {
        leave.status = status
      }
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },
  actions: {
    async fetchLeaves({ commit }) {
      try {
        commit('SET_LOADING', true)
        const leaves = await leavesService.getAll()
        commit('SET_LEAVES', leaves)
      } catch (error) {
        commit('SET_ERROR', error.message)
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async submitLeave({ commit }, leaveData) {
      try {
        commit('SET_LOADING', true)
        const leave = await leavesService.create(leaveData)
        commit('ADD_LEAVE', leave)
        return true
      } catch (error) {
        commit('SET_ERROR', error.message)
        return false
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async updateLeaveStatus({ commit }, { id, status }) {
      try {
        commit('SET_LOADING', true)
        await leavesService.updateStatus(id, status)
        commit('UPDATE_LEAVE_STATUS', { id, status })
        return true
      } catch (error) {
        commit('SET_ERROR', error.message)
        return false
      } finally {
        commit('SET_LOADING', false)
      }
    }
  },
  getters: {
    getPendingLeaves: state => {
      return state.leaves.filter(leave => leave.status === 'قيد الانتظار')
    },
    getLeavesByEmployee: state => employeeId => {
      return state.leaves.filter(leave => leave.employeeId === employeeId)
    }
  }
} 